import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { fadeInOut } from 'assets/TS/SharedAnimations';
import { WizardStepItem } from '../edit-wizard/wizard-step-title/wizard-step-title.component';
import { LRSMap } from 'assets/TS/LRSMap_New';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ActivityService } from 'app/services/activity.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { GfoService } from 'app/services/gfo.service';
import { LayerService } from 'app/services/layer.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { MainDataService } from 'app/services/main-data.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { DrawEvent } from 'ol/interaction/Draw';
import WKT from 'ol/format/WKT';

interface ActionItem {
	label: string;
	prop: ActionType;
}
type ActionType = 'edit' | 'delete' | 'add';
type StepType = 'selectAction' | 'pickLine';
interface GeomEditStepItem extends WizardStepItem {
	prop: StepType;
}

@Component({
  selector: 'app-line-geom-edit-wizard',
  templateUrl: './line-geom-edit-wizard.component.html',
  styleUrls: ['./line-geom-edit-wizard.component.css'],
  animations: [fadeInOut]
})
export class LineGeomEditWizardComponent implements OnInit, AfterViewInit, OnDestroy {


	steps: GeomEditStepItem[] = [
		{
			num: 1,
			label: 'Please select an edit option',
			prop: 'selectAction',
			isFirst: true,
			// isSameLine: true
		}, 
		{
			num: 2,
			label: '', // 'Select centerlines on map',
			prop: 'pickLine',
			// isSameLine: true
		}, {
			num: 3,
			label: 'Select a road centerline to be associated with',
			prop: null,
			isLast: true
		}
	];
	currentStep: GeomEditStepItem;

	actions: ActionItem[] = [{
		label: 'Modify',
		prop: 'edit'
	}, {
		label: 'Add',
		prop: 'add'
	}, {
		label: 'Delete',
		prop: 'delete'
	}];
	currentAction: ActionType;
	isNetworkTopoOn = true; // For network editing: keep topoMode or not

	private hasModifiedData: boolean;

	private selectedRoadsById: {
		[id: string]: {
			feat?;
			attrs?;
		}
	} = {};
	private changedLines: {
		[id: string]: {
			startAttrs;
		}
	}
	private centerlineLayerId;
	// private centerlineCate: LayerCategory;
	private map: LRSMap.Map;

	private editListHoldSub: Subscription;
	private mapSub: Subscription;
	private networkTopoModeSub: Subscription;

	constructor(
		private toastr: ToastrService,
		private activityService: ActivityService,
		private appinfoService: AppinfoService,
		private attrIndexService: AttrIndexService,
		private commonService: CommonFunctionService,
		private floatPopupService: FloatPopupService,
		private gfoService: GfoService,
		private layerService: LayerService,
		private qcService: LayerQcService,
		private mainDataService: MainDataService,
		private mapLayerService: MainDataMapLayersService,
		private mapService: MainDataMapService
	) { }

	close () {
		this.cancel();
	}
	cancel() {
		this.activityService.refreshData.next();
		this.removeAll();
		this.floatPopupService.closePopup(LineGeomEditWizardComponent);
	}

	addCards() {
		switch (this.currentAction) {
			case 'delete':
				Object.keys(this.selectedRoadsById).forEach((id) => {
					let attrs = this.mainDataService.getDataAttrs(id);
					if (!attrs) {
						console.log('need debug: cannot find attrs.');
						return;
					}
					this.mainDataService.setDataAttrs(id, this.attrIndexService.isDeletedKey, true);
					this.mainDataService.addRecToCard(id);
				});
				break;
			case 'edit':
			case 'add':
				const editHoldIds = this.activityService.editRecordHoldListBS.getValue().ids;
				const editedIds = this.activityService.editRecordHoldListBS.getValue().ids;
				editHoldIds.forEach(recId => {
					if (editedIds.indexOf(recId) === -1) {
						editedIds.push(recId);
					}
				});
				this.activityService.editRecordListBS.next({
					ids: editedIds,
					source: 'main'
				});
				break;
		}

		this.removeAll();
		this.activityService.changeTabSubject.next({
			tabKey: 'data'
		});
		this.floatPopupService.closePopup(LineGeomEditWizardComponent);
	}
	checkAddCardsDisabled(stepType: StepType) {
		if (stepType !== 'pickLine') {
			return true;
		}
		switch (this.currentAction) {
			case 'add':
			case 'edit':
				return !this.hasModifiedData;
			case 'delete':
				if (!Object.keys(this.selectedRoadsById).length) {
					return true;
				}
				break;
		}
	}

	onSelectAction() {
		const step = this.steps.find(s => s.prop === 'pickLine');
		if (this.currentStep.num >= step.num) {
			// TODO: remove pick up, etc



		}
		this.changeCurrentStep(step);
	}

	toggleNetworkTopoMode() {
		// this.isNetworkTopoOn = !this.isNetworkTopoOn;
		this.activityService.networkTopoMode.next({
			isOn: this.isNetworkTopoOn
		});
	}

	private removeAll() {
		this.stopPick();
		this.stopEdit();
		this.mapService.removeMapDblclickStop(this.map);
		if (this.map.addedLayers[this.mapLayerService.addressLineLayerName]) {
			this.map.removeLayer(this.mapLayerService.addressLineLayerName);
		}
		this.activityService.editRecordHoldListBS.next({
			ids: []
		})
	}
	private stopPick() {
		this.mapService.endPickOnMap(this.map);
		this.mapService.removeMapDblclickStop(this.map);
	}
	private startPickLinesDelete() {
		const layers = [this.mapLayerService.dataLayerName];
		this.mapService.startPickOnMap(this.map, layers, async (result) => {
			const line = result.feat;
			if (line) {
				const lineLayer = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
				const featId = line.getId();
				let info = this.selectedRoadsById[featId];
				if (info) {
					delete this.selectedRoadsById[featId];
					lineLayer.getSource().removeFeature(line);
				} else {
					await this.updateRoadsInfo([featId]);
					info = this.selectedRoadsById[featId]
					info.feat = line;
					lineLayer.getSource().addFeature(line);
				}
			} else {
				this.toastr.info('Centerline not found.')
			}
		}, null, this.attrIndexService.cursorArrow);
		this.mapService.addMapDblclickStop(this.map, () => {
			this.mapService.endPickOnMap(this.map);
		});
	}
	private startEdit(id?) {
		if (!this.mapService.mapEditing.getValue().isOn) {
			this.mapService.mapEditing.next({
				isOn: true,
				source: 'control',
				selectedId: id
			});
		}
	}
	private stopEdit() {
		if (this.mapService.mapEditing.getValue().isOn) {
			this.mapService.mapEditing.next({
				isOn: false,
				source: 'control'
			});
		}
	}
	private startAdd() {
		const dataLayer = this.map.addedLayers[this.mapLayerService.dataLayerName];
		this.mapService.addDrawInteraction(this.map, 'LineString', dataLayer);
		this.mapService.drawInteraction.on('drawend', (e: DrawEvent) => {
			this.mapService.removeDrawInteraction(this.map);
			const feat = e.feature;
			const rec = this.mainDataService.addNewCard(this.attrIndexService.rcUuidCol, 'control', true);
			const recId = rec[this.attrIndexService.rcUuidCol];
			// set geom
			const wktFormat = new WKT();
			const wktStr = wktFormat.writeGeometry(feat.getGeometry());
			this.mainDataService.setDataAttrs(recId, this.attrIndexService.geomColManual, wktStr);
			feat.setId(recId);
			if (this.activityService.networkTopoMode.getValue().isOn) {
				this.mapService.updateCenterlineTopo(feat, true);
			}
			// Wait till the feature is added to dataLayer before startEdit
			setTimeout(() => {
				this.startEdit(recId);
			});
		})
		// this.mapService.addNewGeomSubject.next();
	}

	private changeCurrentStep(step: GeomEditStepItem) {		
		switch (step.prop) {
			case 'selectAction':
				break;
			case 'pickLine':
				if (this.currentAction === 'delete') {
					step.label = 'Select centerlines on map to delete';
					this.startPickLinesDelete();
				} else if (this.currentAction === 'edit') {
					step.label = 'Edit a RCL, double click to end';
					this.startEdit();
				} else if (this.currentAction === 'add') {
					step.label = 'Single click to digitize RCL vertices, double click to end';
					this.startAdd();
				}
		}
		this.currentStep = step;
	}

	private async updateRoadsInfo(featIds: string[]) {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const idsWithoutAttr = featIds.filter(id => {
				if (!this.selectedRoadsById[id] || !this.selectedRoadsById[id].attrs) {
					const attrs = this.mainDataService.getDataAttrs(id);
					if (attrs) {
						if (!this.selectedRoadsById[id]) {
							this.selectedRoadsById[id] = {}
						}
						this.selectedRoadsById[id].attrs = attrs;
						return false;
					}
					return true;
				}
			});
			if (idsWithoutAttr.length) {
				const filter = this.gfoService.getFilter(this.attrIndexService.rcUuidCol, this.appinfoService.filterOperators.in.name, idsWithoutAttr);
				const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
				const rsp = await this.qcService.getQcFeatureReport(this.centerlineLayerId, null, gfo, {
					pageNumber: 0
				});
				if (rsp.data) {
					rsp.data.forEach(data => {
						const featId = data[this.attrIndexService.rcUuidCol];
	
						this.mainDataService.addDataToStoredRecords([data], this.attrIndexService.rcUuidCol, 'replace');
						
						if (!this.selectedRoadsById[featId]) {
							this.selectedRoadsById[featId] = {}
						}
						this.selectedRoadsById[featId].attrs = data;
					});
				} else {
					this.toastr.warning('Can not find centerline attributes.');
				}
			}
		} catch (err) {
			console.log(err)
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	ngOnInit() {
		this.activityService.removeCurrentSelection();

		this.changeCurrentStep(this.steps[0]);
		// this.currentAction = this.actions[0].prop;
		// this.onSelectAction();

		this.centerlineLayerId = this.layerService.layerListBS.getValue().layers.find(l => l.category.code === this.attrIndexService.cateCodeCenterline).id;

	}
	ngAfterViewInit(): void {
		this.mapSub = this.mapService.mapBS.subscribe(data => {
			this.map = data;
			if (!this.map.addedLayers[this.mapLayerService.addressLineLayerName]) {
				this.mapLayerService.addAddressLineLayer(this.map);
			}
		});

		this.networkTopoModeSub = this.activityService.networkTopoMode.subscribe(data => {
			this.isNetworkTopoOn = data.isOn;
		});

		this.editListHoldSub = this.activityService.editRecordHoldListBS.subscribe(data => {
			if (data.ids && data.ids.length) {
				this.hasModifiedData = true;
			} else {
				this.hasModifiedData = false;
			}
		});
	}
	ngOnDestroy(): void {
		this.editListHoldSub.unsubscribe();
		this.mapSub.unsubscribe();
		this.networkTopoModeSub.unsubscribe();
	}

}
